module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="mealpicker">\n  <h2><input type="text" name="name" value="'+
((__t=( name ))==null?'':_.escape(__t))+
'" id="name"\n    class="textfield" placeholder="Name" /></h2>\n  <p><label for="description">Description</label></p>\n  <p>\n    <textarea name="description" id="description"\n    style="width: 90%" rows="6" maxlength="300" class="textfield"\n    placeholder="A bit of text to describe the menu. This is displayed on Joinos for parents as well"\n    >'+
((__t=( description ))==null?'':_.escape(__t))+
'</textarea>\n  </p>\n\n  <div class="week-holder"></div>\n  <a class="week-add" href="#">\n    New Week <span class="icon icon-plus add_address">+</span>\n  </a>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/picker.html
// module id = 271
// module chunks = 0